import type { RootState } from 'src/state';

const TRIAL_LENGTH_DAYS = 30;
const TRIAL_LENGTH = TRIAL_LENGTH_DAYS * 24 * 60 * 60;

export function selectSubscription(state: RootState) {
  return state.subscription;
}

export function get_trial_expired(state: RootState): boolean {
  const trial_duration = get_trial_duration(state);

  return trial_duration > TRIAL_LENGTH;
}

export function get_trial_duration(state: RootState): number {
  return Math.floor(Date.now() / 1000 - state.subscription.trial_since);
}

export function get_trial_duration_as_days(state: RootState): number {
  return Math.floor(get_trial_duration(state) / (24 * 60 * 60));
}

export function get_trial_length_days() {
  return TRIAL_LENGTH_DAYS;
}

export function show_trial_expired(state: RootState): boolean {
  return get_trial_expired(state) && !state.subscription.active;
}

export function is_subscription_active(state: RootState): boolean {
  return state.subscription.active;
}
